import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const List = () => import('../views/practice-plan/List.vue')
const Edit = () => import('../views/practice-plan/Edit.vue')
const Detail = () => import('../views/practice-plan/Detail.vue')
const WeekDetail = () => import('../views/practice-plan/WeekDetail.vue')
const RTemplateList = () => import('../views/summer/TemplateList.vue')
const REditTemplateRoot = () => import('../views/summer/EditTemplateRoot.vue')
const RTemplateEditGeneral = () => import('../views/summer/TemplateEditGeneral.vue')
const HomeworkDrillSelector = () => import('../views/homework/DrillSelector.vue')
const RHomeworkPlanPreview = () => import('../views/summer/TemplatePreview.vue')

const prefix = 'practice'

export const templateListRoute: RouteConfig = {
  path: `/${prefix}/template-list`,
  name: `${prefix}_template_list`,
  component: RTemplateList,
  meta: {
    title: '作业模板',
  },
  props: (route) => ({ index: route.query.i }),
}

export const templateCustomRoute: RouteConfig = {
  path: `/${prefix}/template-edit`,
  component: REditTemplateRoot,
  redirect: `/${prefix}/template-edit/item`,
  meta: {
    title: '作业内容',
  },
  props: (route) => ({ index: route.query.i }),
  children: [
    {
      path: 'item',
      name: `${prefix}_template_edit_item`,
      component: RTemplateEditGeneral,
      meta: {
        title: '作业内容',
        [GlobalConfigRouteMetaEnum.All]: true,
      },
      props: (route) => ({
        index: route.query.index,
        i: route.query.i,
        form: route.query.form ? JSON.parse(`${route.query.form}`) : 'null',
      }),
    },
    {
      path: 'drills',
      name: `${prefix}_template_edit_drills`,
      component: HomeworkDrillSelector,
      meta: {
        title: '选择项目',
      },
      props: (router) => ({
        ids: router.query.ids || [],
      }),
    },
  ],
}

export const templatePreviewRoute: RouteConfig = {
  path: `/${prefix}/template-preview`,
  name: `${prefix}_template_preview`,
  component: RHomeworkPlanPreview,
  meta: {
    title: '作业预览',
  },
  props: (route) => ({
    template: route.query.template ? JSON.parse(route.query.template as string) : null,
    index: route.query.index,
    i: route.query.i,
  }),
}

const routes: RouteConfig[] = [
  {
    path: `/${prefix}-list`,
    name: `${prefix}_list`,
    props: (route) => ({ ...route.query, ...route.params }),
    component: List,
    meta: {
      title: '体测练习',
    },
  },
  {
    path: `/${prefix}-detail`,
    name: `${prefix}_detail`,
    component: Detail,
    props: (route) => ({ ...route.query, ...route.params, id: route.query.id }),
    meta: {
      title: '体测练习详情',
    },
  },
  {
    path: `/${prefix}-edit`,
    name: `${prefix}_edit`,
    component: Edit,
    meta: {
      title: '体测练习编辑',
    },
  },
  {
    path: `/${prefix}-hw-detail`,
    name: `${prefix}_hw_detail`,
    component: WeekDetail,
    meta: {
      title: '练习详情',
    },
  },
  templateListRoute,
  templateCustomRoute,
  templatePreviewRoute,
]

export function navigateToPracticePlanList(router: VueRouter, activityId: string) {
  router.push({ name: `${prefix}_list`, query: { activityId } })
}

export function navigateToPracticePlanDetail(router: VueRouter, id: string) {
  router.push({ query: { id }, name: `${prefix}_detail` })
}
export function navigateToPracticePlanEdit(router: VueRouter) {
  router.push({ name: `${prefix}_edit` })
}
export function navigateToPracticePlanHwDetail(router: VueRouter) {
  router.push({ name: `${prefix}_hw_detail` })
}

export default [...routes]
